module.exports = __webpack_public_path__ + "img/GALLERY-SWIFT-SPORT-3.fdfe129a.jpg";